import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";
import { Link } from "react-router-dom";
import { useLoadCounter } from "hooks/useLoadCounter";

export const ScalarConfigurationSection = () => {
  const {
    loading: scalarConfigurationLoading,
    error: scalarConfigurationError,
    response: scalarConfigurationResponse
  } = useFetchGetV2("scalar_configurations?ordering=id");
  const tableLoadCount = useLoadCounter(scalarConfigurationLoading);

  if (scalarConfigurationLoading) {
    return <></>;
  }

  if (scalarConfigurationError) {
    return <></>;
  }

  if (scalarConfigurationResponse) {
    return (
      <>
        <SettingsSection title="Scalar Configurations">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>ID</TableCell>
                  <TableCell data-col={2}>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={scalarConfigurationLoading}
                data-qa_load_count={tableLoadCount}
              >
                {scalarConfigurationResponse &&
                  scalarConfigurationResponse?.results.map(
                    scalar_configuration => (
                      <TableRow key={scalar_configuration.id}>
                        <TableCell data-col={1}>
                          {scalar_configuration.id}
                        </TableCell>
                        <TableCell data-col={2}>
                          <Link
                            to={`/pages/settings/scalar_configuration/${scalar_configuration.id}`}
                          >
                            {`${scalar_configuration.name}`}
                          </Link>
                        </TableCell>
                      </TableRow>
                    )
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </SettingsSection>
      </>
    );
  }
};
